export const VALUATION_LOADER_ENQUIRY_KEY = 'valuationLoaderRenderedEnquiry';
